import Decimal from 'decimal.js-light';

// export const roundPrice = (value: number, fixed?: number, sizes?: string[]) => {
//     const param: any = {};
//     const k = 1000000;
//     const fixedNumber = fixed ?? 2;
//     const sizesNumber = sizes ?? ['', '万', '亿', '万亿'];
//     // 获取单位
//     const i = Math.floor(Math.log(value) / Math.log(k));
//     param.value = Math.floor(+(String(value / k ** i) + 'e' + String(fixedNumber))) / 10 ** fixedNumber;
//     const plus: boolean = value % 100000 === 0 ? false : true;
//     param.unit = sizesNumber[i];
//     if (i > 0) {
//         param.value = param.value.toFixed(fixedNumber);
//         if (param.value[param.value.length - 1] === '0' && param.value[param.value.length - 2] === '0') {
//             param.value = param.value.substring(0, param.value.length - 3);
//         } else if (param.value[param.value.length - 1] === '0') {
//             param.value = param.value.substring(0, param.value.length - 1);
//         }
//     }

//     const result = `${param.value as number}${param.unit as string}`;
//     return plus ? `${result}+` : result;
// };

// // 计算价格
// // 价格--最多保留两位小数，若小数点后最后一位为0，不显示，如7.50元，应显示为7.5元
// export function getPrice(price: number, isAccurate = false) {
//     try {
//         if (!price) {
//             return '';
//         }
//         const priceStr = new Decimal(price).toFixed(2);
//         if (price < 10000 || isAccurate) {
//             if (priceStr.endsWith('0') && priceStr[priceStr.length - 2] === '0') {
//                 return priceStr.substring(0, priceStr.length - 3);
//             }
//             if (priceStr.endsWith('0')) {
//                 return priceStr.substring(0, priceStr.length - 1);
//             }
//         } else if (!isAccurate) {
//             return roundPrice(price);
//         }
//         return priceStr;
//     } catch (e) {
//         console.error(e);
//         return '';
//     }
// }

//进度条渲染方法
export function getPercentBySoldNumber(soldNumber: number) {
    if (soldNumber < 10000) {
        return 1 / 2;
    } else {
        return 2 / 3;
    }
}

//将浮点数展示成X%的形式
export function convertToPercentage(discount: number) {
    const percentage = Math.round(discount * 100);
    return `${percentage}%`;
}

export function formatSoldNumber(soldNum: number, unit?: string) {
    if (soldNum < 10000) {
        return soldNum.toString();
    } else {
        const soldStr = new Decimal(soldNum).div(10000).toFixed(1);
        if (soldStr.endsWith('0')) {
            const number = soldStr.substring(0, soldStr.length - 2);
            return `${number as string}${unit || 'w'}`;
        }
        return `${soldStr as string}${unit || 'w'}`;
    }
}

export function getPrice(price: number) {
    try {
        if (!price) {
            return '';
        }

        const priceStr = new Decimal(price).toFixed(2);

        if (priceStr.endsWith('0') && priceStr[priceStr.length - 2] === '0') {
            return priceStr.substring(0, priceStr.length - 3);
        }

        if (priceStr.endsWith('0')) {
            return priceStr.substring(0, priceStr.length - 1);
        }
        return priceStr;
    } catch (e) {
        console.error(e);
        return '';
    }
}
